import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import * as actions from '../actions';
import * as selectors from '../selectors';
import ClientDetail from './ClientDetail';
import { fetchSessionsIfNeeded } from '../../sessions/actions';
import { fetchLocationsIfNeeded } from '../../locations/actions';
import { getUpcomingByClient } from '../../sessions/selectors';
import locations from '../../locations';
import misc from '../../misc';

const ClientDetailToJS = misc.lib.toJS(ClientDetail);

export class ClientDetailContainer extends Component {
  componentDidMount() {
    this.props.fetchClientsIfNeeded();
    this.props.fetchSessionsIfNeeded();
    this.props.fetchLocationsIfNeeded();
    this.props.setActive(this.props.match.params.id);
  }

  render() {
    const { ui } = this.props;
    return (
      <ClientDetailToJS
        client={this.props.client}
        isLoading={ui.get('isLoading')}
        isError={ui.get('isError')}
        errorMessage={ui.get('errorMessage')}
        sessions={this.props.sessions}
        allClients={this.props.allClients}
        allLocations={this.props.allLocations}
      />
    );
  }
}

const mapStateToProps = createStructuredSelector({
  client: selectors.getActive,
  ui: selectors.getUI,
  sessions: getUpcomingByClient,
  allClients: selectors.getEntities,
  allLocations: locations.selectors.getEntities
});

export default connect(mapStateToProps, {
  ...actions,
  fetchSessionsIfNeeded,
  fetchLocationsIfNeeded
})(ClientDetailContainer);



// WEBPACK FOOTER //
// ./src/modules/clients/components/ClientDetailContainer.js